declare global {
  interface Window {
    __API_BASE_URL__?: string;
  }
}

export function validateRuntimeEnv(): void {
  if (typeof window === "undefined") return;

  const hasExplicitApi =
    Boolean(typeof process !== "undefined" && process.env.REACT_APP_API_URL?.trim()) ||
    Boolean(window.__API_BASE_URL__?.trim());

  if (!hasExplicitApi) {
    // eslint-disable-next-line no-console
    console.warn(
      "[taxmanagement] REACT_APP_API_URL is unset and window.__API_BASE_URL__ is missing. " +
        "Some environments infer the API host from the page URL; if requests fail, set REACT_APP_API_URL in .env " +
        `(NODE_ENV=${String(process.env.NODE_ENV)}).`
    );
  }
}
